module.exports = __webpack_public_path__ + "media/images/company/cp16-d701685fab8c7747206a282dc7803d82.png";